import styled from '@emotion/styled'

import { Spacing } from '../../../../enums/spacing'

export const PaneItemChild = styled.div`
  margin-top: -${Spacing.S8};
  margin-bottom: -${Spacing.S8};
`
